import { getMonthBefore } from "@/commons/dateDiffUtil.js";
import { getNewDate } from "@/commons/dateDiffUtil.js";

export default {
  // lấy dữ liệu
  SET_TRANSACTIONS(state, transactions) {
    state.transactions = transactions.items;
    state.totalAmount = transactions.customData.totalAmount;
    state.totalFeeAmount = transactions.customData.totalFeeAmount;
    state.paginations.totalItems = transactions.totalCount;
  },
  /**
   * Set show item select status
   */
  SET_SHOW_STATUS(state) {
    state.isShowItemStatus = !state.isShowItemStatus;
  },

  /**
   * Đóng select item status
   */
  SET_CLOSE_STATUS(state) {
    state.isShowItemStatus = false;
  },
  /**
   * Set show item select card
   */
  SET_SHOW_TYPE_SERVICE(state) {
    state.isShowItemTypeService = !state.isShowItemTypeService;
  },

  /**
   * Đóng select card
   */
  SET_CLOSE_TYPE_SERVICE(state) {
    state.isShowItemTypeService = false;
  },
  /**
   * Set show item select card
   */
  SET_SHOW_TYPE_PAYMENT(state) {
    state.isShowTypePayment = !state.isShowTypePayment;
  },

  /**
   * Đóng select card
   */
  SET_CLOSE_TYPE_PAYMENT(state) {
    state.isShowTypePayment = false;
  },
  /**
   * Set show item select card
   */
  SET_SHOW_STORE(state) {
    state.isShowStore = !state.isShowStore;
  },

  /**
   * Đóng select card
   */
  SET_CLOSE_STORE(state) {
    state.isShowStore = false;
  },

  /**
   * Ẩn hiện popup mở rộng
   */
  SET_SHOW_EXTEND(state) {
    state.isShowExtend = !state.isShowExtend;
  },
  /**
   * Ẩn hiện popup refund
   */
  SET_SHOW_POPUP_REFUND(state) {
    state.isShowPopUpRefund = !state.isShowPopUpRefund;
  },
  /**
   * Tính tổng tiền giao dịch các loại
   */
  TOTAL_AMOUNT(state) {
    // state.totalAmount = state.totalFeeAmount = state.totalOrderAmount = 0;
    // state.transactions.forEach((e) => {
    //     state.totalAmount += e.amount;
    // });
    // state.transactions.forEach((e) => {
    //     state.totalFeeAmount += e.feeAmount;
    // });
    // state.transactions.forEach((e) => {
    //     state.totalOrderAmount += e.orderAmount;
    // });
  },
  /**
   * filter combobox
   *  */
  SELECT_FILTER(state) {
    state.isShowExtend = false;
    state.paginations.start = 0;
    state.paginations.page = 0;
  },

  /**
   * Refresh lại tham số filter
   * @param {*} state
   */
  RESET_INPUT_FILTER(state) {
    state.filters.serviceCode = "";
    state.filters.orderId = "";
    state.filters.merchantCode = "";
    state.filters.cardNumber = "";
    state.filters.paymentType = "";
    state.filters.branch = "";
    state.filters.status = "";
    state.filters.startDate = getMonthBefore();
    state.filters.endDate = getNewDate();
    state.statusRefunds.id = "";
    state.isShowExtend = false;

    state.nameStore = "Tất cả";
    state.nameType = "Tất cả";
  },

  /**
   * lấy tên drop store
   * @param {} state
   * @param {*} payload
   */
  SET_NAME_STORE(state, name) {
    state.nameStore = name;
  },

  /**
   * Lấy tên drop paymentType
   * @param {} state
   * @param {*} payload
   */
  SET_NAME_TYPE(state, name) {
    state.nameType = name;
  },
};
